import config from '@/config';
import { requests } from '.';
export const ContactServices = {
    searchContacts: params => requests(config.CONTACTS_SERVICE_URL).post('/search', params),
    createContact: params => requests(config.CONTACTS_SERVICE_URL).post('/?version=14-05-22', params),
};
